import i18next from 'i18next';

i18next.addResources('es_CL', 'OrdersTable', {
  created: 'Pedidos pendientes de aceptación',
  preparing: 'Pedidos en preparación',
  ready: 'Pedidos Preparados',
  products: 'Productos bloqueados',
  history: 'Historial de pedidos',
  creationScheduled: 'Pedidos Programados'
});

i18next.addResources('es_CR', 'OrdersTable', {
  created: 'Pedidos pendientes de aceptación',
  preparing: 'Pedidos en preparación',
  ready: 'Pedidos Preparados',
  products: 'Productos bloqueados',
  history: 'Historial de pedidos',
  creationScheduled: 'Pedidos Programados'
});
